/* unplugin-vue-components disabled */import { render } from "./songLyric.vue?vue&type=template&id=6e95b97d&scoped=true&ts=true"
import script from "./songLyric.vue?vue&type=script&lang=ts&setup=true"
export * from "./songLyric.vue?vue&type=script&lang=ts&setup=true"

import "./songLyric.vue?vue&type=style&index=0&id=6e95b97d&lang=scss&scoped=true"

import exportComponent from "E:\\Workspaces\\VScode\\vue3+TS\\vue案例\\cloudMusicProject-master\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e95b97d"],['__file',"src/baseui/player/songLyric.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6e95b97d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6e95b97d', __exports__)) {
    console.log('reload')
    api.reload('6e95b97d', __exports__)
  }
  
  module.hot.accept("./songLyric.vue?vue&type=template&id=6e95b97d&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('6e95b97d', render)
  })

}


export default __exports__